import React, { useEffect } from 'react';

import { Link, useNavigate, useRouteError } from 'react-router-dom';
import { Container } from 'react-bootstrap';

import Icon from 'components/DesignSystem/Icon';
import Button from 'components/DesignSystem/Button';
import SubtitleRegular from 'components/Typography/SubtitleRegular';
import BodyRegular from 'components/Typography/BodyRegular';
import { sendInterfaceErrorToSentry } from 'helper/sendErrorToSentry';

import './ErrorPage.scss';

const SUPPORT_EMAIL_HREF = 'mailto:desenvolvimento@ampereconsultoria.com.br';

export default function ErrorPage() {
  // Como errorElement do router, useRouteError traz o crash de render que nos
  // trouxe aqui; como rota /error (navegação), vem undefined. Reportar ao
  // Sentry distingue os dois caminhos da tela genérica — issue #1841 (F4).
  const routeError = useRouteError();

  useEffect(() => {
    if (routeError) {
      sendInterfaceErrorToSentry('RENDER CRASH', 'ErrorPage via errorElement do router', routeError);
    }
  }, [routeError]);

  const navigate = useNavigate();

  return (
    <Container className="error-page">
      <div className="error-page__wrapper">
        <div className="error-page__icon" aria-hidden="true">
          <Icon iconType="warning" size="large" />
        </div>

        <h1 className="title-bold error-page__title">Algo não saiu como esperado</h1>
        <SubtitleRegular>Tivemos um problema ao carregar esta página.</SubtitleRegular>
        <BodyRegular>
          Tente novamente em alguns instantes. Se o problema continuar,
          {' '}
          <a href={SUPPORT_EMAIL_HREF} className="error-page__support-link">
            fale com o nosso suporte
          </a>
          .
        </BodyRegular>

        <div className="error-page__actions">
          <Button icon="refresh" onClick={() => navigate(-1)}>
            Tentar novamente
          </Button>
          <Link to="/home" className="error-page__home-link">
            Voltar para a home
          </Link>
        </div>
      </div>
    </Container>
  );
}
